<template>
  <div>
    <v-container fluid>
      <v-layout wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar class="firstPan">
              <template v-slot:extension>
                <v-tabs
                  v-model="firstPanTabs"
                  fixed-tabs
                  show-arrows
                >
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab v-for="form in section_forms" :key="form.id"
                    :href="'#firstPan'+form.id"
                    class="primary--text"
                    @click="switchPDF(form)"
                  >
                    {{form.section.name}}
                  </v-tab>
                </v-tabs>
              </template>
            </v-toolbar>
            <v-flex xs12 >
              <v-progress-linear
                  v-if="loading"
                  indeterminate
                ></v-progress-linear>
            </v-flex>
            <v-layout>
              <v-flex xs5>
                <v-tabs-items v-model="firstPanTabs">
                  <v-tab-item
                    v-for="form in section_forms" :key="form.id"
                    :value="'firstPan'+form.id"
                  >
                    <v-form
                      :ref="`form-${form.id}`"
                    >
                      <v-simple-table height=1100 dense >
                        <template v-slot:default>
                          <tbody v-if="form.value && Object.keys(form.value).length">
                            <tr v-for="field in form.value" :key="field.id">
                              <td style="border-bottom: none;">
                                <v-textarea
                                  v-if="form.value.length==1"
                                  required
                                  rows="15"
                                  :label="field.field.name"
                                  v-model="field.field.value"
                                  :rules="[rules.required]"
                                  :disabled="loading"
                                ></v-textarea>
                                <v-textarea
                                  v-else
                                  required
                                  rows="1"
                                  :label="field.field.name"
                                  v-model="field.field.value"
                                  :rules="[rules.required]"
                                  :disabled="loading"
                                ></v-textarea>
                              </td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                            <tr v-for="field in form.section_fields" :key="field.id">
                              <td style="border-bottom: none;">
                                <v-textarea
                                  v-if="form.section_fields.length==1"
                                  required
                                  rows="15"
                                  :label="field.field.name"
                                  v-model="field.field.value"
                                  :rules="[rules.required]"
                                  :disabled="loading"
                                ></v-textarea>
                                <v-textarea
                                  v-else
                                  required
                                  rows="1"
                                  :label="field.field.name"
                                  v-model="field.field.value"
                                  :rules="[rules.required]"
                                  :disabled="loading"
                                ></v-textarea>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                      <v-flex xs12>
                        <v-layout>
                          <v-flex xs7>
                            <div class="text-xs-center" style="text-align: center;">
                              <span v-if="form.value && Object.keys(form.value).length">
                                This form was saved at <br /> {{ form.updated_on | formatDate }}
                              </span>
                              <span v-else>
                                This form has not been saved and will not be included in final package.
                              </span>
                            </div>
                          </v-flex>
                          <v-flex xs3>
                            <div class="text-xs-center" style="text-align: center;">
                              <v-btn color="rtsPrimary" dark @click="saveSectionData(form)" :loading="loading">Save</v-btn>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-form>
                  </v-tab-item>
                </v-tabs-items>
              </v-flex>
              <v-flex xs7>
                <pdfViewer :syncTabs="syncTab" :pdfURL="documentPath" :syncPackages="syncPackages"> </pdfViewer>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-simple-table :fixed-header="true">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    PDF Name
                  </th>
                  <th class="text-left" style="color: #2c6d80;">Date & Time</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="finalPackage.length == 0">
                  <td colspan="2">Package has not been generated yet.</td>
                </tr>
                <tr v-for="fPackage in finalPackage" :key="fPackage.id">
                  <td style="cursor: pointer; color: blue;"><span @click="loadPDF(fPackage.file)">{{  fPackage.name }} </span></td>
                  <td>{{ fPackage.created_on | formatDate }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import pdfViewer from '@/components/pdfViewer.vue'
import {
  GETSECTIONSBYTEMPLATEID,
  GETSECTIONSDATABYORDERID,
  UPDATEORDERFIELDDATA,
  CREATEFINALPACKAGE,
  GETFINALPACKAGE
} from '@/store/actions.type'

Vue.filter('formatAddress', function (value) {
  if (value) {
    return value.street + ', ' + value.county.name + ', ' + value.zip_code
  }
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return new Date(value).toLocaleString(
      'en-US', { timeZone: 'America/Los_Angeles', hourCycle: 'h23' }
    ).replace(',', '')
  }
})

export default {
  name: 'DataEntryForms',
  components: {
    pdfViewer
  },
  data () {
    return {
      files: [],
      firstPanTabs: null,
      selected: [],
      loading: false,
      sections: null,
      section_forms: null,
      documentPath: null,
      finalPackage: [],
      syncTab: null,
      syncPackages: new Date().getTime(),
      rules: { required: value => !!value || 'Required.' }
    }
  },
  props: ['order'],
  mounted () {
  },
  methods: {
    switchPDF (section) {
      let allowedTabs = ['tax', 'deed', 'invol lien', 'mortgage', 'other']
      if (allowedTabs.includes(section.section.name.trim().toLowerCase())) {
        if (section.section.name.trim().toLowerCase() === 'tax') {
          this.syncTab = 'taxes'
        }
        if (section.section.name.trim().toLowerCase() === 'deed') {
          this.syncTab = 'deeds'
        }
        if (section.section.name.trim().toLowerCase() === 'invol lien') {
          this.syncTab = 'invol liens'
        }
        if (section.section.name.trim().toLowerCase() === 'mortgage') {
          this.syncTab = 'mortgages'
        }
        if (section.section.name.trim().toLowerCase() === 'other') {
          this.syncTab = 'others'
        }
      }
    },
    getFinalPackage () {
      let payload = {
        order__id: this.order.id
      }
      this.$store
        .dispatch(GETFINALPACKAGE, payload)
        .then(response => {
          this.finalPackage = response.results
        })
    },
    getSectionFields () {
      let payload = {
        template__id: this.order.client.template.id
      }
      this.$store
        .dispatch(GETSECTIONSBYTEMPLATEID, payload)
        .then(response => {
          let sections = response.results
          for (var i = 0; i < sections.length; i++) {
            sections[i]['form_data'] = null
            for (var j = 0; j < sections[i].section_fields.length; j++) {
              sections[i].section_fields[j].field['value'] = null
            }
          }
          this.getSectionFieldsData(sections)
          this.loading = false
        })
    },
    getSectionFieldsData (sec) {
      let sections = sec
      let payload = {
        order__id: this.order.id
      }
      this.$store
        .dispatch(GETSECTIONSDATABYORDERID, payload)
        .then(response => {
          console.log(response, sections)
          for (var i = 0; i < sections.length; i++) {
            for (var j = 0; j < response.results.length; j++) {
              if (sections[i].section.name === response.results[j].section.name) {
                sections[i] = response.results[j].value
                sections[i]['form_data'] = response.results[j]
              }
            }
          }
          this.sections = sections
          console.log(sections)
        })
    },
    getSectionFieldsFormData () {
      let payload = {
        order__id: this.order.id
      }
      this.$store
        .dispatch(GETSECTIONSDATABYORDERID, payload)
        .then(response => {
          console.log(response.results)
          this.section_forms = response.results
        })
    },
    saveSectionData (form) {
      console.log(form)
      this.loading = true
      let valid = false
      let refForm = `form-${form.id}`
      for (const ref in this.$refs) {
        if (ref === refForm) {
          valid = this.$refs[ref][0].validate()
        }
      }
      if (valid === false) {
        alert('All fields are required')
        this.loading = false
        return false
      }
      let sectionData = null
      if (!form.value) {
        sectionData = {
          id: form.id,
          order: form.order.id,
          value: form.section_fields,
          section: form.section.id
        }
      } else {
        sectionData = {
          id: form.id,
          order: form.order.id,
          value: form.value,
          section: form.section.id
        }
      }
      // sectionData = {
      //   id: form.id,
      //   order: form.order.id,
      //   value: form.section_fields,
      //   section: form.section.id
      // }
      console.log(sectionData)
      this.$store
        .dispatch(UPDATEORDERFIELDDATA, sectionData)
        .then(response => {
          console.log(response)
          this.loading = false
          form.updated_on = response.updated_on
          form.value = response.value
          this.createFinalPackage()
          alert('Form Updated')
        })
    },
    createFinalPackage () {
      this.loading = true
      let finalPackagePayload = {
        order: this.order.id,
        name: `RTS-Order-Summary-${this.order.id}-${new Date().getTime()}.pdf`
      }
      this.$store
        .dispatch(CREATEFINALPACKAGE, finalPackagePayload)
        .then(response => {
          alert('Package created!!!')
          this.loading = false
          this.getFinalPackage()
        })
    },
    loadPDF (file) {
      this.documentPath = null
      this.documentPath = file
    }
  },
  watch: {
    order: {
      immediate: true,
      handler (newVal, oldVal) {
        console.log(this.order, newVal, oldVal)
        this.getFinalPackage()
        this.getSectionFieldsFormData()
      }
    }
  }
}
</script>

<style>
body {
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size: 14px;
  line-height: 1.428571429;
  color: #333;
  background-color: #e7edf0;
}
.order-data-table {
  height: 100vh;
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: auto
}
.v-data-table td {
  font-size: 10px;
  font-weight: bold;
}
.v-chip__content {
  font-size: 10px;
  font-weight: bold;
}
.v-data-table td, .v-data-table th {
  padding: 0 5px;
}

.statusTab {
    color: #fff !important;
    background-color: #00abab !important;
    border-color: #00abab;
    width: 120px;
    height: 50px !important;
    display: table-cell;
    vertical-align: middle;
    margin-right: 40px;
    font-size: 10px !important;
    font-weight: 900;
}

.activeStatusTab {
    background-color: #4e6692 !important;
    border-color: #4e6692 !important;
    color: #fff !important;
    width: 120px;
    height: 50px !important;
    display: table-cell;
    vertical-align: middle;
    margin-right: 40px;
    font-size: 10px !important;
    font-weight: 900;
}

.statusTabLine {
  width: 100%;
}

.statusTabLine:before {
    width: 96%;
    background: #d9544f;
    content: "";
    height: 1px;
    position: relative!important;
    padding: 2px;
    top: 40px!important;
    left: 0!important;
    margin: auto;
    display: inline-block;
}

.orderContainer {
  width: 90%;
  margin: auto;
  background-color: white;
  min-height: 800px;
}

.orderHeader {
  width: 90%;
  margin: auto;
  padding: 0px;
  border-bottom: none;
  font-family: 'Open Sans', sans-serif;
  font-size: 24px;
  font-weight: 600;
  padding-top: 10px;
  padding-bottom: 10px;
}

.firstPan > .v-toolbar__content {
    height: 0px !important;
}
.v-sheet--tile {
    height: 60px !important;
}
</style>
